import Sketcher from "../model/Sketcher";
import Screenshotter from "../model/Screenshotter";
import I18N from "oc-I18N";
import {v3} from "oc-threejs/short3";
import DeviceDetection from "oc-commons/DeviceDetection";
import InterieurDragBox from "../object3d/InterieurDragBox";
import HeightDragHandle from "../object3d/HeightDragHandle";
import Fach from "../object3d/Fach";
import {Scene} from "three";
import Urls from "oc-commons/Urls";
import Commons from "oc-commons/Commons";
import UiSphere from "../object3d/UiSphere";

export default class uiActions {
    static _saveAction(onSuccess, onError) {
        uiActions._saveCfg((data) => {
            const afterShoot = () => {
                const searchParams = new URLSearchParams(window.location.search)
                searchParams.set("Code", data.Code);
                const newRelativePathQuery = window.location.pathname + '?' + searchParams.toString();
                window.history.pushState(null, '', newRelativePathQuery);
                // TODO, das ist Mist
                /* let link = window.location.href.split("?")[0] + "?Code=" + data.Code;
                window.history.replaceState({}, "", link); */
                APP.configuration.Code = data.Code;
                onSuccess(window.location.href, data);
            };
            //Right now Screenshoting doesnt work on mobile iOS (iPad iOS does work! Maybe performance?)
            if (DeviceDetection.isIOS() && DeviceDetection.isSmartPhone()) {
                afterShoot();
            } else {
                uiActions._makeImages(data, afterShoot);
            }

        }, onError);
    }

    static _saveCfg(callback, errorcallback) {
        APP.save(callback, errorcallback);
    }

    static _makeImages(data, callback) {

        const hideOtherSchraenke = (displaySchrank) => {
            APP.arrangement.schraenke.forEach(schrank => {
                if (displaySchrank !== schrank) schrank.object3d.visible = false;
            });
        }

        const displayAllSchraenke = () => {
            APP.arrangement.schraenke.forEach(schrank => {
                schrank.object3d.visible = true;
            });
        }

        const changeVisibility = (schrank, visible = true) => {
            schrank.object3d.traverse((child) => {
                const classes = [HeightDragHandle, UiSphere];
                classes.forEach(clazz => {
                    if (child instanceof clazz) {
                        child.visible = visible;
                    }
                })
            })
        }

        let sketcher;
        const screenshotter = new Screenshotter();

        const steps = [];
        APP.arrangement.schraenke.forEach((schrank, index) => {
            const screenshot1 = {
                prepare: () => {
                    hideOtherSchraenke(schrank);
                    changeVisibility(schrank, false);
                    const schrankbox = schrank.getBox3World();
                    APP.model.setFullCam({object3d: schrankbox, direction: schrank.worldNormale});
                    APP.arrangement.object3d.ruler.visible = false;
                    APP.model.showDoorsClosed(true, 0);
                    if (schrank.options.getBool("screenshot_ohne_raum")) APP.arrangement.raum.object3d.visible = false;
                },
                name: `screenshot_${index}_closed.jpg`,
                restore: () => {
                    displayAllSchraenke();
                    changeVisibility(schrank, true);
                    if (schrank.options.getBool("screenshot_ohne_raum")) APP.arrangement.raum.object3d.visible = true;
                },
            }
            steps.push(screenshot1);
            const screenshot2 = {
                prepare: () => {
                    const schrankbox = schrank.getBox3World();
                    APP.model.setFullCam({object3d: schrankbox, direction: schrank.worldNormale});
                    hideOtherSchraenke(schrank);
                    changeVisibility(schrank, false);
                    APP.model.showDoorsClosed(false, 0);
                    if (schrank.options.getBool("screenshot_ohne_raum")) APP.arrangement.raum.object3d.visible = false;
                },
                name: `screenshot_${index}_open.jpg`,
                restore: () => {
                    displayAllSchraenke();
                    changeVisibility(schrank, true);
                    if (schrank.options.getBool("screenshot_ohne_raum")) APP.arrangement.raum.object3d.visible = true;
                },
            }
            steps.push(screenshot2);
            const vorderansicht = {
                prepare: () => {
                    hideOtherSchraenke(schrank);
                    changeVisibility(schrank, false);
                    const schrankbox = schrank.getBox3World();
                    APP.model.setFullCam({object3d: schrankbox, direction: schrank.worldNormale});
                    APP.arrangement.object3d.ruler.visible = false;
                    APP.model.showDoorsClosed(true, 0);
                    if (schrank.options.getBool("screenshot_ohne_raum")) APP.arrangement.raum.object3d.visible = false;
                },
                name: `Vorderansicht.jpg`,
                restore: () => {
                    displayAllSchraenke();
                    changeVisibility(schrank, true);
                    if (schrank.options.getBool("screenshot_ohne_raum")) APP.arrangement.raum.object3d.visible = true;
                },
            }
            steps.push(vorderansicht);
        })

        APP.arrangement.schraenke.forEach((s, i) => {
            steps.push({
                prepare: () => {
                    hideOtherSchraenke(s);
                    APP.model.showDoorsClosed(true, 0);
                    sketcher = new Sketcher(data, s);
                    sketcher.createSketch();
                    STAGE.setDirty();
                },
                name: `sketch_${i.toString()}.jpg`,
                restore: () => {
                    displayAllSchraenke();
                    sketcher.restore();
                },
            });
        });

        const upload = (filename, blob, then) => {
            APP.uploadImage(data.Code, filename, blob, then, () => {
            });
        };

        let current = 0;
        screenshotter.beginShooting();
        const shootOne = () => {
            if (current < steps.length) {
                steps[current].prepare();
                screenshotter.shoot((blob) => {
                    steps[current].restore();
                    upload(steps[current].name, blob, () => {
                        current++;
                        shootOne();
                    });
                }, steps[current].name);
            } else {
                screenshotter.endShooting();
                APP.arrangement.object3d.ruler.visible = true;
                callback();
            }
        };
        shootOne();
    }

    static maybeFotorealisticRender() {
        const prepareInterieurRenderCameras = (sceneSafeClone) => {
            sceneSafeClone.children.forEach((ch) => {
                if (ch.type === "PerspectiveCamera") sceneSafeClone.remove(ch);
            });
            // Create cams for Interieurs
            const cameras = [];
            APP.arrangement.schraenke.forEach((schrank) => {
                schrank.iterateInterieur((interieur) => {
                    if (!(interieur instanceof Einlegeboden)) {
                        const o3 = interieur.jaco3d;
                        // calculate direction for each interieur
                        const lookAt = Scenes.boundingBox(o3, (o) => o.visible).getBoundingSphere().center;
                        const roomCenter = APP.arrangement.raum.box.center();
                        roomCenter.y = 1.8;
                        const direction = roomCenter.sub(lookAt);

                        const vectors = STAGE.getCameraVectorsAsZoomTo(o3, direction, 1);
                        const camera = new THREE.PerspectiveCamera(45, 1, 0.01, 1000);
                        camera.position.copy(vectors[1]);
                        camera.lookAt(vectors[0]);
                        cameras.push(camera);
                    }
                });
            });
            cameras.forEach((c) => sceneSafeClone.add(c));
        };

        const prepareOverviewRenderCameras = (sceneSafeClone) => {
            // Erstellt eine Kamera innerhalb des Raumes
            // Wenn die Kamera um den ganzen Schrank aufnehmen zu können, nicht weiter zurück kann, passt Sie den FOV entsprechend an.
            // Gerechnet wird mit einem natürlichen default FOV von 45Degs
            const createCamera = (position, lookAt, maxDim, maxDistance, cord) => {
                const cameraDistance = maxDim / 2 / Math.tan((Math.PI * 45) / 360);
                let vFOV = 45;

                // cord === x works different in twins
                const setCord = (distance) => {
                    if (cord === "x") {
                        let nb = 1;
                        if (position["x"] < 0) nb = -1;
                        distance = distance * 0.5 * nb;
                    }
                    position[cord] = distance;
                };

                if (cameraDistance > maxDistance) {
                    setCord(maxDistance);
                    // +10 um die Seitenwände zu berücksichtigen
                    vFOV = 2 * Math.atan(maxDim / (2 * (maxDistance - 0.5))) * (180 / Math.PI);
                } else {
                    setCord(cameraDistance);
                }

                const camera = new THREE.PerspectiveCamera(vFOV, 1, 1, 10);
                camera.position.copy(position);
                camera.lookAt(lookAt);
                return camera;
            };

            // Für alle Fälle Kameras erstellen.

            const breite = APP.arrangement.schraenke[APP.arrangement.currentSchrankIndex].size.x;
            const hoehe = APP.arrangement.schraenke[APP.arrangement.currentSchrankIndex].size.y;
            const tiefe = APP.arrangement.schraenke[APP.arrangement.currentSchrankIndex].size.z;

            const cameras = [];
            APP.arrangement.schraenke.forEach(schrank => {
                const o3 = schrank.object3d;
                const lookAt = Scenes.boundingBox(o3, (o) => o.visible).getBoundingSphere().center;
                const roomCenter = v3(0, 120, 200);
                const direction = roomCenter.sub(lookAt);

                const vectors = STAGE.getCameraVectorsAsZoomTo(o3, direction, 1);
                const camera = new THREE.PerspectiveCamera(45, 1, 0.01, 1000);
                camera.position.copy(vectors[1]);
                camera.lookAt(vectors[0]);
                cameras.push(camera);

            });

            cameras.forEach(c => {
                c.position.multiplyScalar(0.01);
                sceneSafeClone.add(c)
            });

            // const cam1 = createCamera({ x: 0, y: hoehe / 2, z: tiefe - 1 }, v3(0, hoehe / 2, 0), breite, tiefe - 0.1, "z");
            // sceneSafeClone.add(cam1);
        };

        if (APP.settings.fotorealisticRender) {
            return APP.fotorealisticRender({
                projectName: "ocschrank_oc",
                filename: "render.glb",
                object3d: scene,
                before: (sceneSafeClone) => {
                    // Das hier ist kurzgesagt: Mist - scaling sollte vorher korrekt sein, etc.
                    // Ist nur ein schneller Test-Workaround gewesen

                    const arrangement = sceneSafeClone.children.find(s => s.currentSchrank);
                    arrangement.scale.multiplyScalar(0.01);
                    const lighgroup = sceneSafeClone.children.find(s => s.name.includes("LightGroup"));
                    lighgroup.children.forEach(l => l.position.multiplyScalar(0.01));
                    sceneSafeClone.children.forEach((ch) => {
                        if (ch.type === "PerspectiveCamera") sceneSafeClone.remove(ch);
                    });
                    // 2 Modes to create Cameras for fotorealistic rendering
                    if (APP.settings.fotorealisticRenderType === "interieur") {
                        prepareInterieurRenderCameras(sceneSafeClone);
                    } else {
                        prepareOverviewRenderCameras(sceneSafeClone);
                    }
                },
                after: (sceneSafeClone) => {
                    //make sceneSafeClone easy accessable for garbage collection
                    sceneSafeClone = null;
                },
                code: APP.configuration.Code,
                instancesToBeHidden: [InterieurDragBox, HeightDragHandle],
                // More data for Rendering, be careful, rendertime can increase dramaticaly
                renderData: {
                    name: "renderData.json",
                    resolution_x: APP.settings.render_resolution_x,
                    resolution_y: APP.settings.render_resolution_y,
                    light_factor: APP.settings.render_light_factor,
                    samples: APP.settings.render_samples,
                },
                useRenderfarm: APP.settings.useRenderfarm
            })
                .catch((e) => {
                    console.error(e);
                });
        } else {
            return APP.wkfgBackendApi.sendKonfigurationMail();
        }
    }

    static save() {
        this.blur = STAGE.freezeRendererAndBlur();

        uiActions._saveAction(
            (link, data) => {
                const pdfUrl = APP.getPdfUrl(data);

                uiActions
                    .maybeFotorealisticRender()
                    .then(() => {
                        this.blur.hideDialog();

                        APP.uiHandler.dialog({
                            title: I18N("saveSuccess"),
                            text: I18N("saveSuccessText", link, link, pdfUrl),
                            buttons: [
                                {
                                    style: "primary",
                                    label: I18N("OK"),
                                    onClick: () => {
                                        let url = APP.settings.redirectAfterSave;
                                        if (!Commons.isEmpty(url)) {
                                            url = url.replace("{Code}", APP.configuration.Code);
                                            location.href = url;
                                        }
                                    },
                                },
                            ],
                        });
                    })
                    .catch((e) => {
                        console.error(e);
                        this.blur.hideDialog();
                        APP.uiHandler.dialog({
                            title: I18N("saveFailed"), //'Speichern ist fehlgeschlagen!',
                            text: I18N("saveFailedText"), //'Wir konnten Ihren Schrank nicht speichern.',
                            buttons: [{style: "primary", label: I18N("OK")}],
                        });
                    });
            },
            (e) => {
                console.error(e);
                APP.uiHandler.dialog({
                    title: I18N("saveFailed"), //'Speichern ist fehlgeschlagen!',
                    text: I18N("saveFailedText"), //'Wir konnten Ihren Schrank nicht speichern.',
                    buttons: [{style: "primary", label: I18N("OK")}],
                });
            }
        );
    }

    static pdf() {
        uiActions._saveAction(
            (link, config) => {
                const pdfUrl = APP.getPdfUrl(config);
                APP.uiHandler.dialog({
                    title: I18N("Pdf erstellt"),
                    text: I18N("Sie können das PDF über folgenden Link öffnen: <br/><br/> <a", pdfUrl, pdfUrl, config.Code),
                    buttons: [{style: "primary", label: I18N("OK")}],
                });
            },
            (e) => {
                console.error(e);
                APP.uiHandler.dialog({
                    title: I18N("saveFailed"), //'Speichern ist fehlgeschlagen!',
                    text: I18N("saveFailedText"), //'Wir konnten Ihren Schrank nicht speichern.',
                    buttons: [{style: "primary", label: I18N("OK")}],
                });
            }
        );
    }

    static basket() {
        const format_Timestamp = (date = new Date()) => {
            const ye = new Intl.DateTimeFormat('en', {year: 'numeric'}).format(date);
            const mo = new Intl.DateTimeFormat('en', {month: '2-digit'}).format(date);
            const da = new Intl.DateTimeFormat('en', {day: '2-digit'}).format(date);
            const h = new Intl.DateTimeFormat('en', {hour12: false, hour: '2-digit'}).format(date);
            const m = new Intl.DateTimeFormat('en', {minute: '2-digit'}).format(date);
            const s = new Intl.DateTimeFormat('en', {second: '2-digit'}).format(date);
            return `${ye}-${mo}-${da} ${h}:${m}:${s}`;
        }
        APP.configuration.ordered_at = format_Timestamp();
        uiActions._saveAction(
            (link, config) => {
                const url = APP.settings.save_to_basket_callback_url.replace("{Code}", config.Code);
                console.log(url, config);
                try {
                    switch (true) {
                        case APP.settings.shop.system == 'woocommerce':
                            $.ajax({
                                url: url,
                                success: function (data) {
                                    const response = data;
                                    if (response) {
                                        window.parent.location = response; //APP.settings.siteUrl+'/checkout/cart/';
                                    } else {
                                        console.warn(data);
                                    }
                                },
                                error: function (e) {
                                    console.error(e);
                                }
                            });

                            break;

                        default:
                            throw('NO SHOPSYSTEM SET');
                    }

                } catch (e) {
                    console.error(e);
                    APP.uiHandler.dialog({
                        title: I18N("addToCartFailed"), //'Speichern ist fehlgeschlagen!',
                        text: I18N("addToCartFailedText"), //'Wir konnten Ihren Schrank nicht speichern.',
                        buttons: [{style: "primary", label: I18N("OK")}],
                    });
                }
            },
            (e) => {
                console.error(e);
                APP.uiHandler.dialog({
                    title: I18N("saveFailed"), //'Speichern ist fehlgeschlagen!',
                    text: I18N("saveFailedText"), //'Wir konnten Ihren Schrank nicht speichern.',
                    buttons: [{style: "primary", label: I18N("OK")}],
                });
            }
        )
    }
}
